import request from '@lib/request'
// 获取素材内容列表
function GetContentList({
  keyword
}) {
  return request
    .get('/institutionAdmin/content/list', {
      params: {
        keyword
      }
    })
    .then(result => {
      return result.data
    })
}
// 上传文件
function UploadFile({
  p_name,
  m_name,
  type,
  videos,
  pdfs,
  audios
}) {
  return request
    .post('/institutionAdmin/content/add', {
      publish_name: p_name,
      material_name: m_name,
      type,
      videos,
      pdfs,
      audios
    })
    .then(response => {
      return response.data
    })
}
// 编辑文件
function EditFile({
  id,
  p_name,
  m_name,
  type,
  videos,
  pdfs,
  audios
}) {
  return request
    .post('/institutionAdmin/content/edit', {
      id,
      publish_name: p_name,
      material_name: m_name,
      type,
      videos,
      pdfs,
      audios
    })
    .then(response => {
      return response.data
    })
}

export default {
  GetContentList,
  UploadFile,
  EditFile
}
